// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-container{bottom:110px;position:fixed;right:10px;z-index:50}.chat-container .chat-cancel-button{background-color:#004890;border:1px solid #06c;border-radius:50%;height:15px;width:15px}.chat-container .chat-cancel-button:hover{background-color:#06c;border:1px solid #004890}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
